import api from './api';

const animatorDashboardService = {
  async getDashboard({ universe, mineOnly, limit } = {}) {
    const params = new URLSearchParams();

    if (universe) params.set('universe', universe);
    if (mineOnly) params.set('mineOnly', '1');
    if (limit != null) params.set('limit', String(limit));

    const query = params.toString();
    const url = query ? `/api/animator/dashboard?${query}` : '/api/animator/dashboard';
    const response = await api.get(url);

    return response.data;
  },
};

export default animatorDashboardService;
